import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { postForm } from '../../ajax'

const RecoveryForm = props => {
  const [recoveryStatus, setRecoveryStatus] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, setValue, formState: { errors }  } = useForm({})

  const successMessage = () => {
    return (
      <span>Please check your email to complete your password request. If you’re having trouble, please contact the <a href='mailto:support@plei.app'>Plei customer support team.</a></span>
    )
  }
  const failMessage = () => {
    return (
      <span>There is no account associated with this email address. If you need access, please contact the <a href='mailto:support@plei.app'>Plei customer support team.</a></span>
    )
  }

  const onSubmit = (data) => {
    setIsLoading(true)
    let formData = new FormData()
    formData.append('authenticity_token', props.authenticityToken)
    for (const key in data) { formData.append(`user[${key}]`, data[key]) }

    postForm('/users/password', formData)
    .then(response => { return response.json() })
    .then((json) => {
      setIsLoading(false)
      setRecoveryStatus({success: !json.error})
    })
  }

  const recoveryForm = () => {
    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='input-container'>
          <label>Email:</label>
          <input
            className={errors.email ? 'error' : ''}
            {...register('email', {
              required: 'This field is required',
              pattern: {
                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
                message: 'Please enter a valid email address'
              } 
            })}
            onChange={(e) => setValue('email', e.target.value)}
            placeholder='example@email.com'
          />
          {errors.email && <div className='error-container'>{errors.email.message}</div>}
        </div>
        <button className='submit-button' type='submit'>
          {isLoading ? <div className='connection-loader'/> : 'Submit'}
        </button>
      </form>
    )
  }

  return (
    <div className='form-container'>
      <img className='logo' src='/images/new-logo.svg'/>
      {
        recoveryStatus
        ? <div className='recovery-message'>
            {recoveryStatus.success ? successMessage() : failMessage()}
          </div>
        : recoveryForm()
      }
      <a onClick={props.onExit}>Back to Login</a>
    </div>
  )
}

export default RecoveryForm
